import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import { Settings } from 'luxon';
import './assets/tailwind.scss';

import '@/styles/main.scss';
import '@/utlitities/filter';

import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

Vue.use(VueDatePicker);

// Options: You can set lang by default
Vue.use(VueDatePicker, {
  lang: 'de',
});

import VSwatches from 'vue-swatches';

// Import the styles too, typically in App.vue or main.js
import 'vue-swatches/dist/vue-swatches.css';

import DefaultLayout from '@/layout/DefaultLayout.vue';
import StCollapse from '@/components/basic/StCollapse.vue';
import StListWrap from '@/components/list/StListWrap.vue';
import { i18n } from '@/localization';
import UnauthorizedLayout from '@/layout/UnauthorizedLayout.vue';
import AuthLayout from '@/layout/AuthLayout.vue';
import StInput from '@/components/basic/StInput.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import { setupAxios } from '@/axios-setup';
import StButton from './components/basic/StButton.vue';
import StSelectButton from './components/basic/StSelectButton.vue';

import './validation/index';
import StListItem from '@/components/list/StListItem.vue';

import VTooltip, { VClosePopover } from 'v-tooltip';
import StConfirmButton from '@/components/basic/ConfirmButton/StConfirmButton.vue';
import StDeleteButton from '@/components/basic/ConfirmButton/StDeleteButton.vue';
import StButtonRound from '@/components/basic/StButtonRound.vue';
import StListItemHeader from '@/components/list/StListItemHeader.vue';

Vue.use(VTooltip, { container: '#app' });
Vue.directive('v-close-popover', VClosePopover);

export let vm: Vue;

Vue.config.productionTip = false;

Vue.component('default-layout', DefaultLayout);
Vue.component('unauthorized-layout', UnauthorizedLayout);
Vue.component('auth-layout', AuthLayout);
Vue.component('export-layout', ExportLayout);
Vue.component('shared-layout', SharedLayout);
Vue.component('administrator-layout', AdministratorLayout);
Vue.component('st-collapse', StCollapse);
Vue.component('st-list-wrap', StListWrap);
Vue.component('st-list-item', StListItem);
Vue.component('st-list-item-wrap', StListItemWrap);
Vue.component('st-list-item-header', StListItemHeader);

Vue.component('st-time-picker', StTimePicker);
Vue.component('st-checkbox', StCheckbox);
Vue.component('st-toggle', StToggle);
Vue.component('st-select', StSelect);
Vue.component('st-input', StInput);
Vue.component('st-input2', StInput2);
Vue.component('st-button', StButton);
Vue.component('st-select-button', StSelectButton);
Vue.component('st-confirm-button', StConfirmButton);
Vue.component('st-button-round', StButtonRound);
Vue.component('st-delete-button', StDeleteButton);
Vue.component('st-datepicker', StDatePicker);
Vue.component('st-textarea', StTextarea);
Vue.component('st-edit-div', StEditDiv);
Vue.component('st-loading', StLoading);
Vue.component('reload-loading', ReloadLoading);
Vue.component('st-explanation', StExplanation);
Vue.component('v-swatches', VSwatches);
Vue.component('st-separator', StSeparator);
Vue.component('st-decimal-input', StDecimalInput);

//Custom Invoice Layouts
Vue.component('OutgoingInvoiceExportHIP', OutgoingInvoiceExportHip);
Vue.component('OutgoingInvoiceExportAbraham', OutgoingInvoiceExportAbraham);

import Notifications from 'vue-notification';
Vue.use(Notifications);

import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

import Clipboard from 'v-clipboard';

Vue.use(Clipboard);

//@ts-ignore

import VueTailwind from 'vue-tailwind';
import TRichSelect from 'vue-tailwind/dist/t-rich-select';
import TDialog from 'vue-tailwind/dist/t-dialog';

Vue.use(VueTailwind, {
  't-rich-select': {
    component: TRichSelect,
  },
  't-modal': {
    component: TModal,
    props: {
      fixedClasses: {
        overlay: 'z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
        wrapper: 'relative mx-auto z-50 max-w-lg px-3 py-20',
        modal: 'overflow-visible relative  rounded-lg',
        body: 'p-8',
        header: 'border-b p-3 rounded-t',
        footer: ' p-3 rounded-b',
        close:
          'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
      },
      classes: {
        overlay: 'bg-black',
        wrapper: '',
        modal: 'bg-white shadow',
        body: 'p-3',
        header: 'border-gray-100',
        footer: 'bg-gray-100',
        close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
        closeIcon: 'fill-current h-4 w-4',
        overlayEnterClass: 'opacity-0',
        overlayEnterActiveClass: 'transition ease-out duration-100',
        overlayEnterToClass: 'opacity-100',
        overlayLeaveClass: 'opacity-100',
        overlayLeaveActiveClass: 'transition ease-in duration-75',
        overlayLeaveToClass: 'opacity-0',
        enterClass: '',
        enterActiveClass: '',
        enterToClass: '',
        leaveClass: '',
        leaveActiveClass: '',
        leaveToClass: '',
      },
      variants: {
        onboarding: {
          overlay: 'z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-80 bg-black',
          wrapper: 'relative mx-auto z-50 max-w-4xl px-3 py-40',
          body: 'p-8',
        },
        danger: {
          overlay: 'bg-red-100',
          header: 'border-red-50 text-red-700',
          close: 'bg-red-50 text-red-700 hover:bg-red-200 border-red-100 border',
          modal: 'bg-white border border-red-100 shadow-lg',
          footer: 'bg-red-50',
        },
      },
    },
  },
  't-dialog': {
    component: TDialog,
    props: {
      variants: {
        danger: {
          overlay: 'z-100 bg-black bg-opacity-50',
          body: 'p-8',
          dialog: 'bg-white shadow-lg rounded-lg text-left',
          wrapper: 'py-20 z-50 max-w-lg px-3',
          titleWrapper: 'py-4 pb-8',
          title: 'text-lg font-bold text-center',
          text: 'px-4 pb-8',

          okButton: 'btn red w-full max-w-xs',
          cancelButton: 'btn white w-full max-w-xs',
        },
        success: {
          overlay: 'z-100 bg-black bg-opacity-50',
          body: 'p-8',
          dialog: 'bg-white shadow-lg rounded-lg text-left',
          wrapper: 'py-20 z-50 max-w-lg px-3',
          titleWrapper: 'py-4 pb-8',
          title: 'text-lg font-bold text-center',
          text: 'px-4 pb-8',
          okButton: 'btn green w-full max-w-xs',
          cancelButton: 'btn white w-full max-w-xs',
        },
      },
    },
  },
});

//@ts-ignore
import draggable from 'vuedraggable';
import StListItemWrap from '@/components/list/StListItemWrap.vue';
import StCheckbox from '@/components/basic/StCheckbox.vue';
import StTimePicker from '@/components/basic/StTimePicker.vue';
import StSelect from '@/components/basic/StSelect.vue';
import StDatePicker from '@/components/basic/StDatePicker.vue';
import StLoading from '@/components/basic/StLoading.vue';

Vue.component('draggable', draggable);

import VueTour from 'vue-tour';
import 'vue-tour/dist/vue-tour.css';

Vue.use(VueTour);

// @ts-ignore
import VueMask from 'v-mask';

Vue.use(VueMask);

import VCalendar from 'v-calendar';

Vue.use(VCalendar);

import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import VueCurrencyFilter from 'vue-currency-filter';
import StTextarea from '@/components/basic/StTextarea.vue';
import StEditDiv from '@/components/basic/StEditDiv.vue';
import ExportLayout from '@/layout/ExportLayout.vue';
import StExplanation from '@/components/basic/StExplanation.vue';
import { setupNumeral } from '@/numeral-setup';

Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeperator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'end',
  symbolSpacing: true,
  avoidEmptyDecimals: undefined,
});

import TextareaAutosize from 'vue-textarea-autosize';

Vue.use(TextareaAutosize);

import wb from './services/service_worker';
import SharedLayout from '@/layout/SharedLayout.vue';
import StToggle from '@/components/basic/StToggle.vue';
import ReloadLoading from '@/components/loading/ReloadLoading.vue';

Vue.prototype.$workbox = wb;

import stHub from '@/signalr/sthub';
import { TModal } from 'vue-tailwind/dist/components';
import StSeparator from '@/components/basic/Form/StSeparator.vue';

Vue.use(stHub);

import { VuePlausible } from 'vue-plausible';
import StDecimalInput from '@/components/basic/StDecimalInput.vue';

Vue.use(VuePlausible, {
  domain: 'app.spiketime.de',
  enableAutoPageviews: false,
});

import VueMarkdown from 'vue-markdown';
import OutgoingInvoiceExportHip from '@/views/OutgoingInvoice/CustomLayouts/OutgoingInvoiceExportHIP.vue';
Vue.component('vue-markdown', VueMarkdown);

//Vue.config.performance = true

import {
  // Directives
  // Components
  Dropdown,
  Tooltip,
  Menu,
} from 'floating-vue';

Vue.component('VDropdown', Dropdown);
Vue.component('VTooltip', Tooltip);
Vue.component('VMenu', Menu);
import 'floating-vue/dist/style.css';
import AdministratorLayout from '@/layout/AdministratorLayout.vue';
import OutgoingInvoiceExportAbraham from '@/views/OutgoingInvoice/CustomLayouts/OutgoingInvoiceExportAbraham.vue';

async function startup() {
  Settings.defaultLocale = 'de';

  vm = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
}

setupAxios();
setupNumeral();
startup();
